import { text_colorTextSecondary } from 'ext-ui/style/colors'
import { font_family_weight_regular, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.AmountInput {
    .currency-static {
      font-family: ${font_family_weight_regular};
      ${font_md};
      color: ${text_colorTextSecondary};
    }
  }
`
